module.exports = __webpack_public_path__ + "assets/img/Main material (11).e14df111.jpg";